import React from 'react';

import OrderForm from '../components/OrderCredit';

const OrderFormPage = () => {
  return <OrderForm />;
};

export default OrderFormPage;
